<template>
  <section id="pricing" class="pb-8 pt-10" style="background-color: rgba(229,243,252,0.5); ">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="9" xl="9">
              <div class="text-center mt-4">
                <h1 class="section-title font-weight-light">Выберите удобный тариф</h1>
                <h4 class="section-subtitle font-weight-light">Оплата после подготовки ваших документов</h4>
              </div>
            </v-col>
          </v-row>
          <v-row align="center" justify="space-around" class="mt-6">
            <v-col cols="12" md="9" xl="9">
              <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    xs="6"
                    md="6"
                    xl="6"
                    class="text-center"
                    v-for="(price, i) in prices"
                    :key="i"
                >
                  <v-hover v-slot:default="{ hover }">
                    <v-card
                        class="card"
                        shaped
                        :elevation="hover ? 10 : 4"
                        :class="{ up: hover }"
                    >
                      <v-img
                          :eager="true"
                          :src="price.img"
                          max-width="100px"
                          class="d-block ml-auto mr-auto"
                          :class="{ 'zoom-efect': hover }"
                      ></v-img>
                      <h1 class="font-weight-regular">
                        {{ price.title }}
                        <v-chip color="red" text-color="white" class="ma-2">
                          {{ price.titleChips }}
                        </v-chip>
                      </h1>
                      <h4 class="font-weight-regular subtitle-1">
                        {{ price.subtitle }}
                      </h4>
                      <p class="text-left description">
                        {{ price.description }}
                      </p>
                      <v-list dense class="text-left enable-options">
                        <v-list-item-group color="primary">
                          <v-list-item @click="$vuetify.goTo('#dialog')">
                            <v-list-item-icon>
                              <v-icon color="#283e79">mdi-checkbox-marked-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title >Консультация по налоговым вычетам</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item
                              v-for="(option, i) in price.enabledOption"
                              :key="i"
                          >
                            <v-list-item-icon>
                              <v-icon color="#283e79">mdi-checkbox-marked-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="option"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                      <v-list dense class="text-left disable-options">
                        <v-list-item-group color="primary">
                          <v-list-item
                              v-for="(option, i) in price.disableOption"
                              :key="i"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-minus-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="option"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                      <v-divider></v-divider>
                      <p class="pa-4 price-text">{{ price.priceText }}</p>
                      <p>
                        <span class="price">{{ price.price }}</span> <span
                          class="price-crossed text-decoration-line-through">{{ price.crossedPrice }}</span>
                        <v-btn class="call-btn-3 v-btn" @click="selectPrice(price.rate)">Заказать</v-btn>
                      </p>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    prices: [
      {
        img: require("@/assets/image/price1.png"),
        title: "Базовый",
        titleChips: "-10%",
        subtitle: "Получите готовую декларацию 3-НДФЛ.",
        description: "Для опытных налогоплательщиков",
        enabledOption: [
          "Гарантия качества услуг",

          "Декларация 3-НДФЛ",
          "Заявление на возврат налога",
        ],
        disableOption: [
          "Иные документы в зависимости от вашей ситуации",
          "Подача документов в налоговую инспекцию",
        ],
        priceText: "Дополнительный год - 790 ₽",
        price: "790 ₽",
        priceValue: "790",
        crossedPrice: "990 ₽",
        rate: 'Базовый (790 ₽)'
      },
      // {
      //   img: require("@/assets/image/price2.png"),
      //   title: "Оптимальный",
      //   titleChips: "-10%",
      //   subtitle: "Получите полный пакет документов.",
      //   description: "Вам останется только подать документы в налоговую",
      //   enabledOption: [
      //     "Консультация по налоговым вычетам",
      //     "Декларация 3-НДФЛ",
      //     "Заявление на возврат налога",
      //     "Иные документы в зависимости от вашей ситуации",
      //   ],
      //   disableOption: [
      //     "Подача документов в налоговую инспекцию",
      //   ],
      //   priceText: "Дополнительный год - 790 ₽",
      //   price: "1 210 ₽",
      //   priceValue: "1210",
      //   crossedPrice: "1 590 ₽",
      //   rate: 'Оптимальный (1 210 ₽)'
      // },
      {
        img: require("@/assets/image/price3.png"),
        title: "Премиум",
        titleChips: "-10%",
        subtitle: "Мы сделаем все за вас.",
        description: "Подготовим и подадим документы в налоговую",
        enabledOption: [
          "Гарантия качества услуг",

          "Декларация 3-НДФЛ",
          "Заявление на возврат налога",
          "Иные документы в зависимости от вашей ситуации",
          "Подача документов в налоговую инспекцию",
        ],
        disableOption: [],
        priceText: "Дополнительный год - 790 ₽",
        price: "1 540 ₽",
        priceValue: "1540",
        crossedPrice: "2 990 ₽",
        rate: 'Премиум (1 540 ₽)',
      },
    ],
  }),
  methods: {
    selectPrice(rate) {
      this.$root.$emit('set-request-rate', rate);
      this.$vuetify.goTo('#request');
    },
  }
};
</script>

<style lang="scss">
$main_color: #283e79;

.card {
  min-height: 300px;
  padding: 15px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.section-subtitle {
  padding-top: 10px;
  font-size: 16px;
  font-weight: 400;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}

.enable-options {
  padding: 0 !important;

  .v-list-item__icon {
    margin-right: 15px !important;
  }

  .v-list-item__title, .v-list-item__subtitle {
    overflow: auto;
    text-overflow: clip;
    white-space: normal;
  }
}

.disable-options {
  padding: 0 !important;

  .v-list-item__icon {
    margin-right: 15px !important;
  }

  .v-list-item__title, .v-list-item__subtitle {
    overflow: auto;
    text-overflow: clip;
    white-space: normal;
  }
}


.description {
  padding-top: 5px;
  font-size: 14px;
}

.price-text {
  font-size: 14px;
  margin-bottom: 0px !important;
}

.price {
  padding-bottom: 0;
  font-size: 24px;
  font-weight: bold;
  color: $main_color;
}

.price-crossed {

}

.call-btn-3 {
  margin-left: 10px;
  background-color: #c42234 !important;
  color: white !important;
}


.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  color: #ffffff !important;
  background: #db2929 !important;
}

.flip-card__top-4digits,
.flip-card__bottom-4digits,
.flip-card__back-bottom-4digits,
.flip-card__back-4digits::before,
.flip-card__back-4digits::after {
  color: #cca900;
  background: #db2929 !important;
}

.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__bottom-4digits,
.flip-card__back-bottom-4digits {
  color: #ffdc00;
  border-top: solid 1px #ffffff !important;
  background: #db2929 !important;
}
</style>